import { render, staticRenderFns } from "./DataFastAdd.vue?vue&type=template&id=8468c210&scoped=true&"
import script from "./DataFastAdd.vue?vue&type=script&lang=js&"
export * from "./DataFastAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8468c210",
  null
  
)

export default component.exports